export const makeNonNullableArray = <T>(value?: MaybeArrayOf<T>): NonNullable<T>[] => {
  if (value === null || value === undefined) return [];

  const items = Array.isArray(value) ? value : [value];

  return items.filter((item): item is NonNullable<T> => item !== null && item !== undefined);
};

export const firstNonNullable = <T>(value?: MaybeArrayOf<T>): NonNullable<T> | undefined =>
  makeNonNullableArray(value)[0];

export const addToDistinctArray = <T>(items: Maybe<T[]>, value: T): T[] => {
  const result = items ?? [];

  return result.includes(value) ? result : [...result, value];
};

export const removeFromDistinctArray = <T>(items: Maybe<T[]>, value: T): T[] =>
  (items ?? []).filter((item) => item !== value);
